<template>
    <v-container>
        <div class="d-md-flex mb-8 line-bottom pb-4">
            <v-skeleton-loader v-if="!sparePart" type="heading"></v-skeleton-loader>
            <h1 class="text-h1 mb-3 mb-md-0" v-else>
                {{ sparePart.name }}
                <v-chip
                    v-if="sparePart.archived"
                    class="ml-2"
                    color="red lighten-2"
                    x-small
                >Discontinued</v-chip>
                <v-chip
                    v-else-if="sparePart.expiring"
                    class="ml-2"
                    color="warning"
                    x-small
                >To be expired</v-chip>
            </h1>
            <v-breadcrumbs v-if="sparePart" :items="breadcrumbs" class="ml-auto pa-0"></v-breadcrumbs>
        </div>

        <div v-if="sparePart" class="mb-6">
            <p class="mb-1">
                <strong>{{ sparePart.itemNo }}</strong>
                <span class="text-capitalize ml-2 text-caption">{{ sparePart.partType }}</span>
            </p>
            <p class="mb-0">
                This part is used in the following product series. Select a series to view its details.
            </p>
        </div>

        <div class="text-center mt-5" v-if="!sparePart">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>

        <v-row class="mb-3" v-if="sparePart">
            <v-col md="8" lg="7">
                <v-list two-line elevation="1" nav class="pa-0">
                    <v-list-item
                        v-for="series in sparePart.productSeries"
                        :key="series.slug"
                        :to="{name: 'CatalogProductSeries', params: { seriesSlug: series.slug }}"
                        class="mb-n1"
                    >
                        <v-list-item-avatar v-if="series.imageUrl" tile size="48" class="my-2 mr-3">
                            <v-img :src="series.imageUrl" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="px-2">
                            <v-list-item-title>
                                {{ series.name }}
                                <v-chip
                                    v-if="series.archived"
                                    class="ml-1"
                                    color="red lighten-2"
                                    x-small
                                >Discontinued</v-chip>
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="series.products && series.products.length > 0">
                                {{ series.products.map(p => p.name).join(', ') }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-btn icon>
                                <v-icon color="grey lighten-1">fal fa-chevron-right</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>

                <v-alert
                    v-if="sparePart.productSeries.length === 0"
                    color="warning"
                    class="my-5"
                >
                    This spare part is not linked to any product series.
                </v-alert>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import apiClient from "@/api/apiClient";

export default {
    name: "CatalogSparePart",
    data: () => ({
        sparePart: null,
    }),
    mounted() {
        this.loadSparePart();
        this.$store.dispatch('setPageTitle', 'Spare part')
    },
    watch: {
        $route() {
            this.loadSparePart();
        }
    },
    computed: {
        breadcrumbs() {
            return [{
                text: 'Home',
                disabled: false,
                to: {name: 'Home'},
                exact: true
            }, {
                text: 'Catalog',
                disabled: false,
                to: {name: 'Catalog'},
                exact: true
            }, {
                text: this.sparePart.name
            }];
        }
    },
    methods: {
        loadSparePart() {
            this.sparePart = null;
            apiClient.get('/spare-part/' + this.$route.params.sparePartId)
                .then(response => {
                    this.sparePart = response.data;
                })
                .catch(() => {
                    this.$store.dispatch('showSnackbar', {color: 'error', text: 'Spare part niet gevonden'});
                });
        },
    }
}
</script>

<style scoped>

</style>
